import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { selectMapProps } from "search-new/selectors"
import { loadMapGeographyData, updateVisualizationSelection } from "search-new/action-creators"

import {
    VisualizationResultsTable
} from 'search-new/components/Visualization/VisualizationSidebars/SidebarTables'

import {
    DownloadButtonGroup,
    ResetFiltersButton,
    OrgDesignSidebarComponent,
} from 'search-new/components/Visualization/VisualizationSidebars/SidebarButtons'

const MapSidebar = props => (
    <div className="sidebar-controls">
        <VisualizationResultsTable
            uniqueFlvId={props.uniqueFlvId}
            uniqueVizSceneId={props.uniqueVizSceneId}
            label={props.sidebarTableLabel || "Results by Region"}
            onRowClick={() => {}}
        />
        <ResetFiltersButton
            uniqueFlvId={props.uniqueFlvId}
            uniqueVizSceneId={props.uniqueVizSceneId}
            disabled={props.disableButtons}
        />
        {
            !props.noOrgDesign &&
            <OrgDesignSidebarComponent
                uniqueFlvId={props.uniqueFlvId}
                uniqueVizSceneId={props.uniqueVizSceneId}
            />
        }
        <DownloadButtonGroup
            uniqueFlvId={props.uniqueFlvId}
            uniqueVizSceneId={props.uniqueVizSceneId}
            disabled={props.disableButtons}
        />
    </div>
)

MapSidebar.propTypes = {
    // from ListViewDisplayWrapper
    uniqueFlvId: PropTypes.string.isRequired,
    uniqueVizSceneId: PropTypes.string.isRequired,
    isVisualizationLoading: PropTypes.bool.isRequired,
    disableButtons: PropTypes.bool,
    sidebarTableLabel: PropTypes.string,
}

export default connect(selectMapProps, { loadMapGeographyData, updateVisualizationSelection })(MapSidebar)
